/**
 * Re-reading a number when you come back to the tab.
 *
 * The collection is not only edited here — Anki desktop and the phone sync to the same hub, so a
 * count read once at mount is a claim that goes stale the moment you study anywhere else. The rail
 * badge had the worst of it: `App` never unmounts, so its due count was fixed for the whole
 * session.
 *
 * Refreshing on focus rather than on a timer keeps the read path's promise — no background sync
 * while you sit reading — and asks only at the one moment the answer might have changed while you
 * were not looking.
 */

/** `focus` and `visibilitychange` both fire on a single tab switch, so a window is needed. */
export const REFRESH_MIN_INTERVAL_MS = 5_000;

export function shouldRefetch(
  lastAt: number,
  now: number,
  minIntervalMs: number = REFRESH_MIN_INTERVAL_MS,
): boolean {
  // `0` is the never-fetched sentinel, and a clock that went backwards (NTP, sleep) must not be
  // able to lock the refresh out until it catches up.
  if (lastAt === 0 || now < lastAt) return true;
  return now - lastAt >= minIntervalMs;
}
